import '~/frontend/cable.js'
import { loadMore } from '~/frontend/finite.js'
import { hideBlockedPosts, ensureFilterButtons, toggleFilter } from '~/frontend/filter.js'

document.addEventListener('DOMContentLoaded', (e) => {
  const observer = new IntersectionObserver(loadMore);
  observer.observe(document.querySelector('#ljbreadcrumbs'));

  document.querySelector('body > #NavMenuList #_toggle-filter').addEventListener('click', toggleFilter);

  hideBlockedPosts();
  ensureFilterButtons();
});
